export default __webpack_public_path__ + "static/media/reactMovie_logo.e1d936f2.png";